import { ForwardRefExoticComponent, HTMLAttributes, ReactNode, RefAttributes, forwardRef } from 'react';
import { combineClassNames } from '../../Utils/ClassnameUtils';

export interface GWPControlGroupProps extends HTMLAttributes<HTMLDivElement> {
	children?: ReactNode;
	fullWidth?: boolean;
}

export interface GWPControlGroupItemProps extends HTMLAttributes<HTMLDivElement> {
	children?: ReactNode;
	grow?: boolean;
}

const GWPControlGroupItem = forwardRef<HTMLDivElement, GWPControlGroupItemProps>((props, ref) => {
	const { children, className, grow = false, ...rest } = props;

	return (
		<div
			ref={ref}
			className={combineClassNames('gwp-control-group-item', grow ? 'grow' : undefined, className)}
			{...rest}
		>
			{children}
		</div>
	);
});

GWPControlGroupItem.displayName = 'GWPControlGroupItem';

type GWPControlGroupComponent = ForwardRefExoticComponent<GWPControlGroupProps & RefAttributes<HTMLDivElement>> & {
	Item: typeof GWPControlGroupItem;
};

const GWPControlGroupRoot = forwardRef<HTMLDivElement, GWPControlGroupProps>((props, ref) => {
	const { children, className, fullWidth = false, ...rest } = props;

	return (
		<div
			ref={ref}
			className={combineClassNames('gwp-control-group', fullWidth ? 'full-width' : undefined, className)}
			{...rest}
		>
			{children}
		</div>
	);
});

GWPControlGroupRoot.displayName = 'GWPControlGroup';

const GWPControlGroup = Object.assign(GWPControlGroupRoot, {
	Item: GWPControlGroupItem,
}) as GWPControlGroupComponent;

export default GWPControlGroup;
